<template>
  <section class="section is-dark">
    <commonModal
      :show="showCallToModal"
      :options="{
        title: 'Call Us',
        description:
          `To speak to a Porsche Auto Insurance customer service concierge, please call us at 
          <a href='tel:1-` +
          $phoneNumber +
          `'>` +
          $phoneNumber +
          `</a>`,
        buttonLabel: 'OK'
      }"
      @close="showCallToModal = false"
    ></commonModal>
    <div class="container">
      <header class="header columns">
        <div class="column">
          <h1 class="title">Welcome back, {{ user.firstName }}.</h1>
        </div>
      </header>
      <div
        v-for="(vehicle, index) in selectedPolicy && selectedPolicy.vehicleInfo"
        :class="{
          'car-chooser': true,
          '-spacing-c': true,
          'car-chooser--open': toggle[index]['parent']
        }"
        :key="vehicle.id"
      >
        <div class="car-chooser__bar" @click="toggleDetails(index, 'parent')">
          <div
            :class="{
              icon: true,
              'icon--arrow-down-hair': true,
              'car-chooser__icon': true,
              'car-chooser__icon--open': toggle[index]['parent']
            }"
          ></div>
          <div class="car-chooser__header">
            <h2 class="car-chooser__title">
              {{ vehicle.year }} {{ vehicle.model }}
            </h2>
          </div>
        </div>
        <div
          :class="{
            'car-chooser__dropdown': true,
            'car-chooser__dropdown--open': toggle[index]['parent']
          }"
        >
          <div
            :class="{
              'account-info': true,
              '-spacing-c': true,
              'account-info--open': toggle[index]['vehicle'],
              [`account-info--vehicle`]: true
            }"
            :key="'vehicle' + index"
          >
            <div
              class="account-info__bar"
              @click="toggleDetails(index, 'vehicle')"
            >
              <div
                :class="{
                  icon: true,
                  'icon--arrow-down-hair': true,
                  'account-info__icon': true,
                  'account-info__icon--open': toggle[index]['vehicle']
                }"
              ></div>
              <div class="account-info__header">
                <h2 class="account-info__title">My vehicle</h2>
              </div>
            </div>
            <div
              :class="{
                'account-info__dropdown': true,
                'account-info__dropdown--open': toggle[index]['vehicle']
              }"
            >
              <div class="columns">
                <div class="account-info__image-wrapper column is-half">
                  <div
                    class="column is-12"
                    v-if="
                      vehicle.vehicleImageResponse &&
                        vehicle.vehicleImageResponse.Vin &&
                        vehicle.vehicleImageResponse.Vin.picture
                    "
                  >
                    <img
                      :src="
                        getVehicleImageFromResponse(
                          vehicle.vehicleImageResponse
                        )
                      "
                      v-bind:alt="'car'"
                    />
                  </div>
                  <div v-else class="column is-12">
                    <img
                      :src="
                        vehicleImgBaseUrl +
                          'images-api/v1/ffddfa3eb8056090b9dd6602d1c910a7/5'
                      "
                      alt="default"
                    />
                  </div>
                </div>
                <dl class="column is-half spacing-reduced">
                  <dt>Year &amp; Model</dt>
                  <dd>
                    {{
                      formatTextToTitleCase(vehicle.year) +
                        ' ' +
                        formatTextToTitleCase(vehicle.make) +
                        ' ' +
                        formatTextToTitleCase(vehicle.model) +
                        ' ' +
                        formatStyleToProperCase(vehicle.bodyStyle)
                    }}
                  </dd>
                  <dt>VIN</dt>
                  <dd>{{ vehicle.vin }}</dd>
                  <dt>Garaging Address</dt>
                  <dd v-if="garagingAddress[0]">
                    {{
                      formatTextToTitleCase(
                        garagingAddress[0] && garagingAddress[0].streetName
                      )
                    }}
                    <br />
                    {{
                      formatTextToTitleCase(
                        garagingAddress[0] && garagingAddress[0].city
                      )
                    }},
                    {{ garagingAddress[0] && garagingAddress[0].state }}&nbsp;
                    {{ garagingAddress[0] && garagingAddress[0].zip }}
                  </dd>
                  <dd v-else>
                    N/A
                  </dd>
                </dl>
              </div>

              <div class="account-info__buttons">
                <button
                  class="account-info__button button-primary button-primary--black"
                  @click="openTelNumModal()"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  ></span>
                  <span class="button-primary__label">Change Address</span>
                </button>

                <button
                  class="account-info__button button-primary button-primary--black"
                  @click="openTelNumModal()"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  ></span>
                  <span class="button-primary__label">Add/Replace Vehicle</span>
                </button>
              </div>
            </div>
          </div>

          <div
            :class="{
              'account-info': true,
              '-spacing-c': true,
              'account-info--open': toggle[index]['policy'],
              [`account-info--policy`]: true
            }"
            :key="'policy' + index"
          >
            <div
              class="account-info__bar"
              @click="toggleDetails(index, 'policy')"
            >
              <div
                :class="{
                  icon: true,
                  'icon--arrow-down-hair': true,
                  'account-info__icon': true,
                  'account-info__icon--open': toggle[index]['policy']
                }"
              ></div>
              <div class="account-info__header">
                <h2 class="account-info__title">My policy</h2>
              </div>
            </div>
            <div
              :class="{
                'account-info__dropdown': true,
                'account-info__dropdown--open': toggle[index]['policy']
              }"
            >
              <div class="columns">
                <dl class="column is-half reduced-height">
                  <dt>Policy Owner</dt>
                  <dd>
                    {{ formatTextToTitleCase(primaryDriverName[0].firstName) }}
                    {{ formatTextToTitleCase(primaryDriverName[0].lastName) }}
                  </dd>
                  <dt>Renewal Date</dt>
                  <dd>{{ renewalDate ? renewalDate : 'To be confirmed' }}</dd>
                  <dt>Mailing Address</dt>
                  <dd v-if="mailingAddress[0]">
                    {{ formatTextToTitleCase(mailingAddress[0].streetName) }}
                    <br />
                    {{ formatTextToTitleCase(mailingAddress[0].city) }},
                    {{ mailingAddress[0].state }}&nbsp;
                    {{ mailingAddress[0].zip }}
                  </dd>
                  <dd v-else></dd>
                </dl>

                <dl class="column is-half reduced-height">
                  <dt>Base Rate</dt>
                  <dd>${{ vehicle.premiumInfo.baseRate }}</dd>
                  <dt>Per Mile Rate</dt>
                  <dd>${{ vehicle.premiumInfo.perMileRate }}</dd>
                  <dt>Account Number</dt>
                  <dd>{{ selectedPolicy.policyNumber }}</dd>
                </dl>
              </div>

              <div class="account-info__buttons">
                <button
                  class="account-info__button button-primary button-primary--black"
                  @click="openTelNumModal()"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  ></span>
                  <span class="button-primary__label">View My Statement</span>
                </button>

                <button
                  class="account-info__button button-primary button-primary--black"
                  @click="requestIDCard()"
                  :disabled="selectedPolicy && !selectedPolicy.insuranceInfo"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  ></span>
                  <span class="button-primary__label">Request ID Card</span>
                </button>
              </div>
            </div>
          </div>

          <div
            :class="{
              'account-info': true,
              '-spacing-c': true,
              'account-info--open': toggle[index]['coverage'],
              [`account-info--coverage`]: true
            }"
            :key="'coverage' + index"
          >
            <div
              class="account-info__bar"
              @click="toggleDetails(index, 'coverage')"
            >
              <div
                :class="{
                  icon: true,
                  'icon--arrow-down-hair': true,
                  'account-info__icon': true,
                  'account-info__icon--open': toggle[index]['coverage']
                }"
              ></div>
              <div class="account-info__header">
                <h2 class="account-info__title">My coverage</h2>
              </div>
            </div>
            <div
              :class="{
                'account-info__dropdown': true,
                'account-info__dropdown--open': toggle[index]['coverage']
              }"
            >
              <div class="columns">
                <dl class="column is-half reduced-height">
                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="coverage.coverageDescription === 'Bodily Injury'"
                      :key="coverage.coverageName"
                    >
                      {{ coverage.coverageDescription }}
                    </dt>
                    <dd
                      v-if="coverage.coverageDescription === 'Bodily Injury'"
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ changeSlashToDash(coverage.displayLimit) }}
                      <br />(Each Person | Each Accident)
                    </dd>
                  </template>

                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="coverage.coverageDescription === 'Property Damage'"
                      :key="coverage.coverageName"
                    >
                      {{ coverage.coverageDescription }}
                    </dt>
                    <dd
                      v-if="coverage.coverageDescription === 'Property Damage'"
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ coverage.displayLimit }}
                      <br />(Each Accident)
                    </dd>
                  </template>

                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="coverage.coverageDescription === 'Comprehensive'"
                      :key="coverage.coverageName"
                    >
                      {{ coverage.coverageDescription }}
                    </dt>
                    <dd
                      v-if="coverage.coverageDescription === 'Comprehensive'"
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ coverage.displayLimit }} (Deductible)
                    </dd>
                  </template>

                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="coverage.coverageDescription === 'Collision'"
                      :key="coverage.coverageName"
                    >
                      {{ coverage.coverageDescription }}
                    </dt>
                    <dd
                      v-if="coverage.coverageDescription === 'Collision'"
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ coverage.displayLimit }} (Deductible)
                    </dd>
                  </template>
                </dl>

                <dl class="column is-half reduced-height">
                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="coverage.coverageDescription === 'Rental'"
                      :key="coverage.coverageName"
                    >
                      Car {{ coverage.coverageDescription }}
                    </dt>
                    <dd
                      v-if="coverage.coverageDescription === 'Rental'"
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ changeSlashToDash(coverage.displayLimit) }}
                      <br />(Each Day | Each Loss)
                    </dd>
                  </template>

                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="coverage.coverageName === 'UMUIMBI'"
                      :key="coverage.coverageName"
                    >
                      Uninsured Bodily
                    </dt>
                    <dd
                      v-if="coverage.coverageName === 'UMUIMBI'"
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ changeSlashToDash(coverage.displayLimit) }}
                      <br />(Each Person | Each Accident)
                    </dd>
                  </template>

                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="
                        coverage.coverageDescription ===
                          'Uninsured Motorist Property Damage'
                      "
                      :key="coverage.coverageName"
                    >
                      Uninsured Property
                    </dt>
                    <dd
                      v-if="
                        coverage.coverageDescription ===
                          'Uninsured Motorist Property Damage'
                      "
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ coverage.displayLimit }}
                      <br />(Each Person | Each Accident)
                    </dd>
                  </template>

                  <template v-for="coverage in vehicle.coverageInfo">
                    <dt
                      v-if="
                        coverage.coverageDescription ===
                          'Personal Injury Protection'
                      "
                      :key="coverage.coverageName"
                    >
                      {{ coverage.coverageDescription }}
                    </dt>
                    <dd
                      v-if="
                        coverage.coverageDescription ===
                          'Personal Injury Protection'
                      "
                      :key="coverage.coverageName + 'value'"
                    >
                      {{ coverage.displayLimit }}
                    </dd>
                  </template>
                </dl>
              </div>

              <div class="account-info__buttons">
                <button
                  class="account-info__button button-primary button-primary--black"
                  @click="openTelNumModal()"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  ></span>
                  <span class="button-primary__label">Change Coverage</span>
                </button>
              </div>
            </div>
          </div>

          <div
            :class="{
              'account-info': true,
              '-spacing-c': true,
              'account-info--open': toggle[index]['drivers'],
              [`account-info--policy`]: true
            }"
            :key="'drivers' + index"
          >
            <div
              class="account-info__bar"
              @click="toggleDetails(index, 'drivers')"
            >
              <div
                :class="{
                  icon: true,
                  'icon--arrow-down-hair': true,
                  'account-info__icon': true,
                  'account-info__icon--open': toggle[index]['drivers']
                }"
              ></div>
              <div class="account-info__header">
                <h2 class="account-info__title">My drivers</h2>
              </div>
            </div>
            <div
              :class="{
                'account-info__dropdown': true,
                'account-info__dropdown--open': toggle[index]['drivers']
              }"
            >
              <div class="columns my-drivers-section">
                <dl
                  v-for="driver in sortedDrivers"
                  :key="driver.licenseNumber"
                  class="column is-half"
                >
                  <dt>Driver</dt>
                  <dd>
                    {{ formatTextToTitleCase(driver.firstName) }}
                    {{ formatTextToTitleCase(driver.lastName) }}
                  </dd>
                  <dt>Date of Birth</dt>
                  <dd>{{ getDate(driver.dob) }}</dd>
                  <dt>Gender</dt>
                  <dd>{{ driver.gender }}</dd>
                  <dt>Marital Status</dt>
                  <dd>{{ driver.isMarried ? 'Married' : 'Single' }}</dd>
                </dl>
              </div>

              <div class="account-info__buttons">
                <button
                  class="account-info__button button-primary button-primary--black"
                  @click="openTelNumModal()"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  ></span>
                  <span class="button-primary__label">Add/Edit Drivers</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AccountInfo from '../../components/account/AccountInfo';
import commonModal from '../../components/shared/commonModal';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import * as _ from 'lodash';

export default {
  name: 'Account',
  data() {
    return {
      toggle: [],
      showCallToModal: false,
      vehicleImgBaseUrl: process.env.VUE_APP_PORSCHE_PIC_BASE_URL
    };
  },
  beforeMount() {
    if (this.selectedPolicy === null) {
      this.$router.push('/account/multiple-policies');
    }
    this.fetchVehicleImages();
    this.initializeToggleArray();
  },
  computed: {
    ...mapGetters(['user', 'policies', 'selectedPolicy']),
    sortedDrivers() {
      return _.orderBy(this.selectedPolicy.driverInfo, 'driverNumber');
    },
    garagingAddress() {
      const result = this.selectedPolicy.addressInfo.filter(address => {
        return address.addressType === 'Garaging';
      });
      return result;
    },
    mailingAddress() {
      const result = this.selectedPolicy.addressInfo.filter(address => {
        return address.addressType === 'Mailing';
      });
      return result;
    },
    renewalDate() {
      return this.selectedPolicy.renewalDate;
    },
    primaryDriverName() {
      const result = this.selectedPolicy.policyOwners.filter(primaryDriver => {
        return primaryDriver.relation === 'INSURED';
      });
      return result;
    }
  },
  components: {
    AccountInfo,
    commonModal
  },
  methods: {
    ...mapActions(['getVehicleImage']),
    ...mapMutations(['setSelectedPolicy']),
    initializeToggleArray() {
      if (this.selectedPolicy && this.selectedPolicy.vehicleInfo) {
        const vehicleInfo = this.selectedPolicy.vehicleInfo;
        const noOfVehicles = vehicleInfo.length;
        for (let i = 0; i < noOfVehicles; i++) {
          let newToggleObj = {
            parent: false,
            policy: false,
            vehicle: false,
            coverage: false,
            drivers: false
          };
          this.toggle.push(newToggleObj);
        }
      }
    },

    formatTextToTitleCase(textString) {
      return _.startCase(_.toLower(textString));
    },
    formatTextCapitalCase(textString) {
      return _.capitalize(textString);
    },
    formatStyleToProperCase(textString) {
      let resultantString = '';
      const containsHyphens = new RegExp('[-]');
      let pipeSplits = textString.split(' | ');
      for (let i = 0; i < pipeSplits.length; i++) {
        const word = pipeSplits[i];
        let wordSplits = word.split(' ');
        for (let j = 0; j < wordSplits.length; j++) {
          const subWord = wordSplits[j];
          if (containsHyphens.test(subWord)) {
            wordSplits[j] =
              subWord.slice(0, 2) +
              subWord.charAt(2).toUpperCase() +
              subWord.slice(3).toLowerCase();
          } else {
            if (subWord.includes('WD') || subWord.includes('DR')) {
              subWord.toUpperCase();
            } else {
              wordSplits[j] = this.formatTextCapitalCase(subWord);
            }
          }
        }
        if (i < pipeSplits.length - 1) {
          resultantString += wordSplits.join(' ') + ' | ';
        } else {
          resultantString += wordSplits.join(' ');
        }
      }
      return resultantString;
    },

    getDate(date) {
      return moment(date).format('MMMM Do, YYYY');
    },

    changeSlashToDash(stringData) {
      return _.replace(stringData, '/', '|');
    },

    toggleDetails: function(index, key) {
      this.toggle[index][key] = !this.toggle[index][key];
    },
    fetchVehicleImages() {
      this.selectedPolicy &&
        this.selectedPolicy.vehicleInfo.forEach((vehicle, index) => {
          this.getVehicleImage({
            vin: vehicle.vin,
            year: vehicle.year,
            model: vehicle.model,
            inAccountPage: true,
            index: index
          });
        });
    },
    getVehicleImageFromResponse(response) {
      if (
        response &&
        response.Vin &&
        response.Vin.picture &&
        response.Vin.picture
      ) {
        let vehicleImg = response.Vin.picture.filter(img => {
          return img._attributes.view === 'extcam02';
        });
        if (vehicleImg && vehicleImg.length) {
          return vehicleImg[0]._attributes.uri;
        } else if (response.Vin.picture[0]) {
          return response.Vin.picture[0]._attributes.uri;
        }
      }
    },
    openTelNumModal() {
      this.showCallToModal = true;
    },
    requestIDCard() {
      if (this.selectedPolicy.insuranceInfo) {
        window.open(
          this.selectedPolicy.insuranceInfo.insuranceCardUri,
          '_blank'
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background-color: $shark;
  color: $white;
  .my-drivers-section {
    flex-wrap: wrap;
  }
}

.title {
  margin-bottom: -0.5rem;
}

.spacing-reduced {
  max-height: 225px;
  @media screen and (max-width: 760px) {
    max-height: unset;
  }
}

.reduced-height {
  dd,
  dt {
    height: 60px;
    @media screen and (max-width: 760px) {
      height: unset;
    }
  }
}
</style>
